<template>
  <div class="importOrders">
    <BaseTitle titleText="匯入訂單資料" />
    <section class="importOrders__header">
      <div
        v-if="fileName"
        class="importOrders__button importOrders__button__clear"
        @click="clearFile"
      >
        <ArrowRightIcon />
        <span>清除資料</span>
      </div>
      <label
        v-else
        class="importOrders__button importOrders__button__add"
        for="importFile"
      >
        <UploadIcon /><span>新增訂單資料</span>
        <input
          id="importFile"
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          @change="fileParse($event)"
        />
      </label>
    </section>
    <section v-if="fileName" class="importOrders__file-view">
      <div class="importOrders__file">
        <FileIcon />
        <span>{{ fileName }}</span>
      </div>
      <button
        class="importOrders__button importOrders__button__upload"
        v-if="dataAllPass && !uploading && !uploadResult"
        @click="uploadData"
      >
        上傳資料
      </button>
      <div v-if="uploadResult === 'y'" class="importOrders__upload-success">
        <SuccessIcon />
        <span>上傳成功</span>
      </div>
      <div v-if="uploadResult === 'n'" class="importOrders__upload-fail">
        <FailIcon />
        <span>上傳失敗</span>
      </div>
      <span v-if="!dataAllPass" class="importOrders__error-message"
        >*檔案資料有誤，請檢查格式後再重新匯入檔案</span
      >
    </section>
    <section class="importOrders__list">
      <b-overlay :show="parsingFile && !this.orders.length" rounded="lg">
        <b-table
          head-variant="light"
          hover
          :fields="ordersHeaders"
          :items="orders"
        >
          <template #cell(deliveryMethod)="{ item }">
            <div>
              {{
                `${deliveryMethodTableMap(Number(item.deliveryMethod))}（${
                  item.deliveryMethod
                }）`
              }}
            </div>
          </template>
        </b-table>
        <div v-if="!orders.length" class="text-center mb-3">目前無資料</div>
      </b-overlay>
    </section>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';
import UploadIcon from '@/assets/images/upload.svg';
import ArrowRightIcon from '@/assets/images/arrow-right.svg';
import FileIcon from '@/assets/images/file.svg';
import SuccessIcon from '@/assets/images/circle-check.svg';
import FailIcon from '@/assets/images/circle-close.svg';

import parseSheet from '@/utils/fileDataParse';
import variant from '@/utils/variant.js';
import { deliveryMethodTableMap } from '@/utils/optionMaps.js';
import { mapActions } from 'vuex';
import { errorMessageParse } from '@/utils/errorMessage';
import { toUTC } from '@/utils/moment.js';

export default {
  name: 'ImportOrders',
  components: {
    BaseTitle,
    UploadIcon,
    ArrowRightIcon,
    FileIcon,
    SuccessIcon,
    FailIcon
  },
  data() {
    return {
      ordersHeaders: [
        {
          key: 'deliveryMethod',
          label: '派單方式'
        },
        {
          key: 'estimateGetOnTime',
          label: '預定上車時間'
        },
        {
          key: 'onLocation',
          label: '上車地點'
        },
        {
          key: 'offLocation',
          label: '下車地點'
        },
        {
          key: 'identityCode',
          label: '身分證號'
        },
        {
          key: 'callNumber',
          label: '司機隊編(呼號)'
        },
        {
          key: 'licenseNumber',
          label: '車牌號碼'
        },
        {
          key: 'seats',
          label: '乘客數'
        }
      ],
      orders: [],
      fileName: null,
      parsingFile: false,
      dataAllPass: true,
      uploading: false,
      uploadResult: null
    };
  },
  methods: {
    ...mapActions({
      uploadOrsers: 'longTerm/uploadOrsers'
    }),
    deliveryMethodTableMap(value) {
      return deliveryMethodTableMap(value);
    },
    async fileParse(e) {
      const data = await parseSheet(e.target.files[0]);
      // 確定輸入的是長照單資料
      if (Object.prototype.hasOwnProperty.call(data[0], 'callNumber')) {
        this.parsingFile = true;
        this.fileName = e.target.files[0].name;
        this.orders = this.dataVariant(data);
      } else {
        this.$store.commit('errorMessage', '請上傳正確的訂單資料');
        this.$root.$emit('bv::show::modal', 'error-modal');
        this.fileName = null;
        this.parsingFile = false;
      }

      this.parsingFile = false;
    },
    clearFile() {
      this.orders = [];
      this.fileName = null;
      this.parsingFile = false;
      this.dataAllPass = true;
      this.uploadResult = null;
    },
    dataVariant(data) {
      const newData = data.map(item => {
        const dataPass = Object.keys(item).every(key => {
          return this.variantRules(key, item[key]);
        });
        if (dataPass) return item;
        else {
          this.dataAllPass = false;
          return { ...item, _rowVariant: 'danger' };
        }
      });
      return newData;
    },
    variantRules(key, value) {
      if (key === 'deliveryMethod') return variant.zeroOneTwo(value);
      if (key === 'callNumber') return variant.numberOnly(value);
      if (key === 'estimateGetOnTime') return variant.dateTime(value);
      if (key === 'identityCode') return variant.identifyCode(value);
      if (key === 'licenseNumber') return variant.licenseNumber(value);
      if (key === 'seats') return variant.numberOnly(value);
      return true;
    },
    async uploadData() {
      this.uploading = true;
      const data = this.orders.map(order => {
        const date = order.estimateGetOnTime.split(' ')[0];
        const time = order.estimateGetOnTime.split(' ')[1];
        return {
          ...order,
          deliveryMethod: Number(order.deliveryMethod),
          // callNumber: Number(order.callNumber),
          seats: Number(order.seats),
          estimateGetOnTime: toUTC(date, time)
        };
      });
      console.log(data);
      try {
        await this.uploadOrsers({
          datas: data
        });
        this.uploading = false;
        this.uploadResult = 'y';
      } catch (err) {
        this.uploading = false;
        this.uploadResult = 'n';
        console.warn('err', err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.importOrders {
  &__header {
    background-color: #edf0f4;
    padding: 20px 35px;
  }
  &__button {
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 10px 20px;
    margin-bottom: 0;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    &__add {
      background-color: $white;
      color: $black;
    }
    &__clear {
      background-color: $negative;
      color: $white;
    }
    &__upload {
      background-color: $positive;
      color: $white;
      border: none;
    }
    svg {
      margin-right: 5px;
    }
  }
  &__file {
    display: flex;
    align-items: center;
    width: fit-content;
    color: $black;
    margin-right: 50px;
    font-size: 1rem;
    svg {
      margin-right: 5px;
    }
    &-view {
      display: flex;
      align-items: center;
      padding: 0 35px;
      margin-top: 30px;
    }
  }
  &__error-message {
    margin-left: 10px;
    color: $negative;
  }
  &__list {
    padding: 30px 35px;
  }
  &__upload {
    &-success {
      display: flex;
      align-items: center;
      color: #00a65a;
      span {
        font-size: 1.1rem;
        margin-left: 5px;
      }
    }
    &-fail {
      display: flex;
      align-items: center;
      color: #ff0000;
      span {
        font-size: 1.1rem;
        margin-left: 5px;
      }
    }
  }
  #importFile {
    display: none;
  }
}
</style>
